const MIN  = 60 * 1000;
const HOUR = 60 * MIN;
const DAY  = 24 * HOUR;

export function formatRelativeTime(when: Date | string): string {
  const past = typeof when === "string" ? new Date(when) : when;
  const delta = Date.now() - past.getTime();

  if (delta < MIN) return "agora";
  if (delta < HOUR) return `há ${Math.floor(delta / MIN)}min`;
  if (delta < DAY)  return `há ${Math.floor(delta / HOUR)}h`;
  if (delta < 2 * DAY) return "ontem";
  if (delta < 7 * DAY) return `há ${Math.floor(delta / DAY)} dias`;

  return past.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" });
}
